import { Configuration } from '~/api/client/configuration';
import type {
  BoatsApiApiV1BoatsGetRequest,
  BoatsApiApiV1BoatsIdCharterTypesGetRequest,
  BoatsApiApiV1BoatsIdGetRequest,
} from '~/api/client/api';
import { BoatsApi } from '~/api/client/api';

import getConfig from 'next/config';
const { publicRuntimeConfig } = getConfig();

const apiConfiguration = new Configuration({
  basePath: publicRuntimeConfig.API_HOST.replace(/\/+$/, ''),
});

const BOATS_API = new BoatsApi(apiConfiguration, apiConfiguration.basePath);

const getBoatsByCoordinates = async (paramsObj: BoatsApiApiV1BoatsGetRequest) => {
  return await BOATS_API.apiV1BoatsGet(paramsObj);
};

const getBoatById = async (paramsObj: BoatsApiApiV1BoatsIdGetRequest) => {
  return await BOATS_API.apiV1BoatsIdGet(paramsObj);
};

const getBoatCharterTypes = async (paramsObj: BoatsApiApiV1BoatsIdCharterTypesGetRequest) => {
  return await BOATS_API.apiV1BoatsIdCharterTypesGet(paramsObj);
};

export { getBoatById, getBoatsByCoordinates, getBoatCharterTypes };
